import type { MarketingPage } from './routes';
import { HomePage } from './pages/HomePage';
import { GetStartedPage } from './pages/GetStartedPage';
import { PrivacyPolicyPage, SupportPage, TermsPage } from '../pages/LegalPages';
import { ContentContext, type SiteContent } from './siteContent';
import './site.css';

export function MarketingPageView({ page }: { page: MarketingPage }) {
  switch (page) {
    case 'get-started': return <GetStartedPage />;
    case 'support': return <SupportPage />;
    case 'privacy': return <PrivacyPolicyPage />;
    case 'terms': return <TermsPage />;
    default: return <HomePage />;
  }
}

export function MarketingApp({ page, content }: { page: MarketingPage; content: SiteContent }) {
  return <ContentContext.Provider value={content}><MarketingPageView page={page} /></ContentContext.Provider>;
}
